import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../../components/Layout/Layout';
import StructuredContentDefault from '../../components/StructuredContentDefault ';
import ImageWrapper from '../../components/Global/Image/ImageWrapper';
import Button from '../../components/Global/Button/Button';
import DateTime from '../../components/Global/DateTime/DateTime';
import DetailDocLayout from '../../components/Layout/DetailDocLayout/DetailDocLayout';
import SeoDatoCms from '../../components/SeoDatoCms';
import Breadcrumb from '../../components/Global/Breadcrumb/Breadcrumb';
import EventList from '../../components/Global/EventList/EventList';
import Section from '../../components/Global/Section/Section';
import TextHubspotForm from '../../components/Blocks/TextHubspotForm/TextHubsportForm';
import GalleryImages from '../../components/Global/GalleryImages/GalleryImages';
import { isEmptyDocument } from 'datocms-structured-text-utils';

import './index.scss';
import FadeIn from '../../components/Global/FadeIn/FadeIn';

function Event({ data: { event, breadcrumb, favicon, siteTitle, relatedEvents } }) {
  const {
    title,
    image,
    eventType,
    registerLink,
    manualDate,
    date,
    time,
    location,
    tags,
    summary,
    textContent,
    documents,
    galleryHeadline,
    images,
    form,
    seo,
    noIndex,
  } = event;

  return (
    <Layout>
      <SeoDatoCms seo={seo} favicon={favicon} siteTitle={siteTitle}>
        {noIndex && <meta name="robots" content="noindex" />}
      </SeoDatoCms>

      <div id="main-content">
        <FadeIn>
          <div className={`event-page event-${tags ? tags.color : ''}`}>
            <div className="header">
              <div className="container">
                {breadcrumb && <Breadcrumb items={breadcrumb} breadcrumbDetail={title} />}

                <div className={`wrapper ${image ? '' : 'no-image'}`}>
                  <div className="meta">
                    <DateTime manualDate={manualDate} date={date} time={time} />
                    <div className="time">
                      {tags ? tags.title : ''} {location ? ` / ${location}` : ''} {time ? ` / ${time}` : ''}
                    </div>
                    <h1>{title}</h1>
                  </div>

                  {image && <ImageWrapper image={image} />}
                </div>
              </div>
            </div>

            {/* Information */}
            {!isEmptyDocument(textContent) && (
              <div className="information">
                <div className="container">
                  <DetailDocLayout documents={documents}>
                    {registerLink && (
                      <Button label={registerLink.label} url={registerLink.url} customVariant={'register-link'} />
                    )}
                    {summary && <div className="summary" dangerouslySetInnerHTML={{ __html: summary }} />}

                    <div className="link-and-list-styles-v2">
                      <StructuredContentDefault content={textContent} />
                    </div>
                  </DetailDocLayout>
                </div>
              </div>
            )}
          </div>

          {/* Extras */}
          {images.length > 0 && <GalleryImages headline={galleryHeadline} images={images.map((i) => ({ image: i }))} />}
          {relatedEvents.edges && relatedEvents.edges.length > 0 && (
            <Section
              title="Related events"
              link={{
                link: {
                  label: 'See all events',
                  content: { slug: 'events', model: { apiKey: 'list_events' } },
                },
              }}
            >
              <div className="col-12">
                <EventList events={relatedEvents.edges} />{' '}
              </div>
            </Section>
          )}
          {form && form[0] && <TextHubspotForm block={{ ...form[0], backgroundColor: 'section-pink' }} />}
        </FadeIn>
      </div>
    </Layout>
  );
}

export const EventQuery = graphql`
  query EventById($id: String, $menuPos: String, $tagId: String) {
    favicon: datoCmsSite {
      faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }
    siteTitle: datoCmsSite {
      globalSeo {
        siteName
      }
    }
    breadcrumb: datoCmsPageStructure(id: { eq: $menuPos }) {
      ...Breadcrumb
    }
    relatedEvents: allDatoCmsEvent(filter: { id: { ne: $id }, tags: { id: { eq: $tagId } } }, limit: 2) {
      edges {
        node {
          ...EventCard
        }
      }
    }
    event: datoCmsEvent(id: { eq: $id }) {
      title
      noIndex
      image {
        alt
        gatsbyImageData
        url
      }
      time
      manualDate
      summary
      location
      date(formatString: "D MMM")
      registerLink {
        ... on DatoCmsGlobalLink {
          ...GlobalLink
        }
      }
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      tags {
        ... on DatoCmsTagEvent {
          title
          id
          color
        }
      }
      eventType {
        ... on DatoCmsEventType {
          title
          icon {
            url
          }
        }
      }
      documents {
        ... on DatoCmsDocument {
          language
          document {
            url
            title
          }
        }
      }
      galleryHeadline
      images {
        url
        alt
        gatsbyImageData
      }
      textContent {
        value
        blocks {
          __typename
          ... on DatoCmsAcordion {
            id: originalId
            items {
              title
              text
            }
          }
          ... on DatoCmsImage {
            id: originalId
            image {
              gatsbyImageData
              alt
              title
            }
          }
        }
      }
      form {
        ...BlockTextHubspot
      }
    }
  }
`;

export default Event;
